// src/api/societyRequest.js
import axios from "axios";
import { BASE_URL } from "./config";

const API = axios.create({ baseURL: BASE_URL });

const config = () => ({
  headers: {
    Authorization: localStorage.getItem("skilloptoken"),
  },
  withCredentials: true,
});

export const getMySocietyProfile = () =>
  API.get("/api/society/me", config());

export const getMembers = () =>
  API.get("/api/society/members", config());

export const addMember = (data) =>
  API.post("/api/society/members", data, config());

export const removeMember = (id) =>
  API.delete(`/api/society/members/${id}`, config());

export const getTasks = () =>
  API.get("/api/society/tasks", config());

export const createTask = (data) =>
  API.post("/api/society/tasks", data, config());
